export function create(store) {
    return (inputValue, errorMessage, vArgs, context) => validate(store, inputValue, errorMessage, vArgs, context);
}

function validate(store, inputValue, errorMessage, vArgs, context) {
    const { ifCondition } = vArgs;

    if (!ifCondition) return true;  // nothing to require

    if (checkCondition(store, ifCondition)) {
        // return a boolean to display the error as label. Returning a string will display the error below the field
        return !!inputValue.trim().length;
    }

    return true;
}

export function checkCondition(store, condition) {
    const [type, ...args] = condition.split(':');

    switch (type) {
        case 'NotEmpty':
            const refField = args[0];
            if (!refField) return false;

            const refValue = store.getters.getCurrentInputValue(refField)

            // check if the reference field is empty
            return !!refValue.trim().length;
        default:
            return false;
    }
}